import routerOptions0 from "/data/teamcity/work/f6010d7a8f2d88ad/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: true,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}